// extracted by mini-css-extract-plugin
export default {"dropdown":"styles_dropdown__vs9tu","dropdownPopover":"styles_dropdown-popover__DZNFW","productCell":"styles_product-cell__IDaFW","table":"styles_table__oYomm"};